import { combineReducers } from '@reduxjs/toolkit'
import localForage from 'localforage'
import blogReducer from '../pages/Blog/blogSlice'
import blogViewReducer from '../pages/Blog/blogViewSlice'
import plansReducer from '../pages/Plans/plansSlice'
import authReducer from './authSlice'
import userReducer from './userSlice'
import profileReducer from './profileSlice'
import subscriptionReducer from '../pages/Account/Subscription/subscriptionSlice'
import passwordReducer from './passwordSlice'
import purchaseHistoryReducer from '../pages/Account/PurchaseHistory/purchaseHistorySlice'
import cartReducer from '../pages/Cart/cartSlice'
import wizardReducer from '../pages/Wizard/wizardSlice'
import businessLogoReducer from '../pages/Business/Settings/logoSlice'
import userClassesReducer from '../pages/Class/MyClasses/userClassesSlice'
import userCoursesReducer from '../pages/Course/userCoursesSlice'
import businessUsersReducer from '../pages/Business/Users/businessUsersSlice'
import { persistReducer } from 'redux-persist'
import categoriesReducer from '../pages/Course/categoriesSlice'
import searchReducer from '../pages/Search/searchSlice'
import wishListReducer from '../pages/WishList/wishListSlice'
import browseClassesReducer from '../pages/Class/BrowseClasses/browseClassesSlice'
import classDetailsReducer from '../pages/Class/ClassDetails/classDetailsSlice'
import browseCoursesReducer from '../pages/Course/BrowseCourses/browseCoursesSlice'
import courseDetailsReducer from '../pages/Course/CourseDetails/courseDetailsSlice'
import viewCourseLessonReducer from '../pages/Course/ViewCourseLesson/viewCourseLessonSlice'
import courseProgressReducer from '../pages/Course/ViewCourseLesson/courseProgressSlice'
import dashboardReducer from '../pages/Homepage/dashboardSlice'
import { ourCoursesReducer } from '../components/OurCourses/ourCoursesSlice'
import { ourClassesReducer } from '../components/OurClasses/ourClassesSlice'
import { beneficiaryDetailsReducer } from '../pages/Business/UserDetails/userDetailsSlice'
import { userActionsReducer } from '../pages/Business/Users/userActionsSlice'
import { homepageReducer } from '../pages/Homepage/homepageSlice'
import companyLogoReducer from '../pages/Beneficiary/Auth/companyLogoSlice'
import beneficiaryCoursesReducer from '../pages/Beneficiary/Courses/beneficiaryCoursesSlice'
import businessBasicsReducer from '../pages/Business/Settings/basicsSlice'
import { recentlyViewedReducer } from './recentlyViewedSlice'
import { cancelSubscriptionReducer } from '../pages/Account/CancelSubscription/cancelSubscriptionSlice'
import aboutUsReducer from '../pages/About/aboutUsSlice'
import courseLessonReducer from '../pages/Course/ViewCourseLesson/courseLessonSlice'

const cartPersistConfig = {
    key: 'cart',
    storage: localForage,
    blacklist: ['itemDetails'],
}

const rootReducer = combineReducers({
    blog: blogReducer,
    blogView: blogViewReducer,
    plans: plansReducer,
    auth: authReducer,
    user: userReducer,
    accountProfile: profileReducer,
    accountSubscription: subscriptionReducer,
    accountPassword: passwordReducer,
    accountPurchaseHistory: purchaseHistoryReducer,
    cart: persistReducer(cartPersistConfig, cartReducer),
    wizard: wizardReducer,
    userClasses: userClassesReducer,
    businessBasics: businessBasicsReducer,
    browseCourses: browseCoursesReducer,
    categories: categoriesReducer,
    userCourses: userCoursesReducer,
    wishList: wishListReducer,
    courseDetails: courseDetailsReducer,
    viewCourseLesson: viewCourseLessonReducer,
    browseClasses: browseClassesReducer,
    courseProgress: courseProgressReducer,
    dashboard: dashboardReducer,
    ourCourses: ourCoursesReducer,
    ourClasses: ourClassesReducer,
    businessUsers: businessUsersReducer,
    beneficiaryDetails: beneficiaryDetailsReducer,
    userActions: userActionsReducer,
    companyLogo: companyLogoReducer,
    beneficiaryCourses: beneficiaryCoursesReducer,
    search: searchReducer,
    classDetails: classDetailsReducer,
    homepage: homepageReducer,
    businessLogo: businessLogoReducer,
    recentlyViewed: recentlyViewedReducer,
    cancelSubscription: cancelSubscriptionReducer,
    aboutUs: aboutUsReducer,
    courseLesson: courseLessonReducer,
})

export default rootReducer
